$('.item-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: true,
        slidesToShow: 2,
      }
    },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 2.5,
//         slidesToScroll: 1,
//         autoplay: true,
//         autoplaySpeed: 2000,
//         dots: true,
//         infinite: true
//       }
//     }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$('.new-grid').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  arrows: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 5,
        arrows: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        infinite: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
$(document).ready(function() {
    // var tempintervalId = setInterval(function () {
    //   console.log($('.product-tabs__content').length,$('.cbb-frequently-bought-container').length)
    //     if ($('.product-tabs__content').length > 0 && $('.cbb-frequently-bought-container').length > 0) {
    //         // Stop the interval once the element is found
    //         var parent = $('.cbb-frequently-bought-container').parent();
    //         var html_content = $('.cbb-frequently-bought-container');
    //           $(".cbb-frequently-bought-container").remove();
    //         parent.append(html_content);
    //         // var contentToMove = $(".cbb-frequently-bought-container").html();
    //         // var contMove = "<div class='container-fluid'>" + contentToMove + "</div>";
    //         // $(".cbb-frequently-bought-container").empty();
    //         // $(".custom_product_tab_section").before(contMove);
    //         clearInterval(tempintervalId);
    //     }
    // }, 500);
  
    // setTimeout(function () {
    //     clearInterval(tempintervalId);
    // }, 10000);

});


